/**
 * SlxControls 1.2.41 ({@link https://www.selerix.com})
 * This is unpublished proprietary source code of Selerix Systems, Inc. The
 * copyright notice above is not evidence any actual or intended
 * publication of such source code.
 * @copyright Copyright 2025 Selerix Systems, Inc. All Rights Reserved.
 */
(function (global) {
	'use strict';
	var x = global.SlxControl;

	/**
	 * slx.calendar
	 * @requires slx.core
	 */
	x.slx.calendar = function () {
		var that = this;
		x.slx.base.apply(that, arguments);

		// reference current element
		var el = that._element;
		if (el === void 0) { return this; }
		else if (el.length === 0) { return el; }

		// get date locale and language
		var _getLocale = function(lang) {
			if (!Date['locale']) {
				return Date.addLocale();
			} else if (!lang) {
				return Date['locale'];
			}

			return Date['locale'][lang] || Date['locale']['en'];
		};

		// set custom settings from data props and attributes
		that.id = that.id || el.slxUniqueId();
		that.selector = '#' + that.id;
		that.showControls = that.showControls || el.data('showcontrols');
		that.onChange = typeof that.onChange === 'function' ? that.onChange : el.attr('onchange') !== void 0 ? x.eval.call(el[0], el.attr('onchange'), 'event') : void 0;
		that.view = that.view || el.data('view') || 'month';
		that.lang = that.lang && (that.lang in _getLocale()) ? that.lang : 'en';
		that.format = that.format || el.data('format') || _getLocale(that.lang).format;
		that.mobileMaxWidth = that.mobileMaxWidth || el.data('mobile-maxwidth') || 767;
		that.html5 = that.html5 || el.data('html5') === false ? false : true;

		// local flags and references
		var _today = new Date(), _current = new Date(_today.getFullYear(), _today.getMonth(), 1);
		_today.setHours(0); _today.setMinutes(0); _today.setSeconds(0); _today.setMilliseconds(0);
		var _hidden = x(that.selector + '_value');
		var _controls = { container: null, previous: null, month: null, year: null, next: null }, _table;

		// break date format into month, day, year parts
		var _formatParts;
		(function() {
			// get a part of the format
			var getPart = function(i, part) {
				return {
					index: i,
					length: part.length,
					value: part
				};
			};

			// get each format part
			var year, month, day;
			var formatParts = that.format.split(/[\/-]/);
			for (var i = 0; i < formatParts.length; i++) {
				var p = formatParts[i];
				if (p.indexOf('M') > -1) {
					month = getPart(i, p);
				} else if (p.indexOf('d') > -1) {
					day = getPart(i, p);
				} else if (p.indexOf('y') > -1) {
					year = getPart(i, p);
				}
			}

			// set internal variable
			_formatParts = {
				month: month,
				day: day,
				year: year,
				length: formatParts.length
			};
		})();

		// set default view
		that.view = !_formatParts.day ? 'year' : that.view;

		// get previous timeframe
		var _getPrevious = function (view) {
			switch (view) {
				case 'year':
					// previous year
					return new Date(_current.getFullYear() - 1, 0, 1);
				case 'decade':
					// previous decade
					return new Date(_current.getFullYear() - 12, 0, 1);
				default:
					// previous month
					return new Date(_current.getFullYear(), _current.getMonth() - 1, 1);
			}
		};
		// get next timeframe
		var _getNext = function (view) {
			switch (view) {
				case 'year':
					// next year
					return new Date(_current.getFullYear() + 1, 0, 1);
				case 'decade':
					// next decade
					return new Date(_current.getFullYear() + 12, 0, 1);
				default:
					// next month
					return new Date(_current.getFullYear(), _current.getMonth() + 1, 1);
			}
		};

		// get and set value
		that.value = function (v) {
			if (v === void 0) {
				// get value
				return _hidden.slxVal();
			} else {
				// set value
				var ischange = v !== _hidden.slxVal();
				var h = _hidden.slxVal(v);
				// trigger change event
				if (ischange) {
					_hidden.trigger('change');
					el.trigger('change');

					// trigger viewchange event
					var d = that.dateValue();
					if ((_formatParts.day && d.getMonth() !== _current.getMonth()) || d.getFullYear() !== _current.getFullYear()) {
						_current = new Date(d.getFullYear(), d.getMonth(), 1);
						el.trigger('viewchange.slx.calendar');
					}
				}

				return h;
			}
		};
		// get and set text
		that.text = function (v) {
			if (v === void 0) {
				// get text
				return el.slxVal();
			} else {
				// set text
				if (v === '') { that.value(''); }
				return el.slxVal(v);
			}
		};
		// get and set value using Date object
		that.dateValue = function (v) {
			// get date value
			if (v === void 0) {
				var parts = _hidden.slxVal().split(/[\D]/);
				var m = _formatParts.month ? parts[_formatParts.month.index] : '01';
				var d = _formatParts.day ? parts[_formatParts.day.index] : '01';
				var y = _formatParts.year ? parts[_formatParts.year.index] : '0000';

				return new Date(y, m - 1, d);
			}
			// set date value
			else if (v instanceof Date) { that.value(v.toString(that.format)); }
		};

		// table cell click handler
		var _cellClick = function () {
			// get current table
			var c = _table.data('current'), d = x(this).data('date');
			_table.find('.active').removeClass('active');
			x(this).addClass('active');

			// switch to month view
			var _switchToMonth = function () {
				that.view = 'month';
				_table.removeClass('slx-calendar-view-year').removeClass('slx-calendar-view-decade').addClass('slx-calendar-view-month');
				_controls.month.show();
				_current = d;
				// trigger viewchange
				el.trigger('viewchange.slx.calendar');
			};

			// switch to year view
			var _switchToYear = function () {
				that.view = 'year';
				_table.removeClass('slx-calendar-view-month').removeClass('slx-calendar-view-decade').addClass('slx-calendar-view-year');
				_controls.month.hide();
				_current = d;
				// trigger viewchange
				el.trigger('viewchange.slx.calendar');
			};

			// switch view
			switch (that.view) {
				case 'decade':
					// switch from decade to year view
					_switchToYear();
					break;
				case 'year':
					// switch from year to month view
					if (_formatParts.day) {
						_switchToMonth();
					} else {
						that.dateValue(d);
					}
					break;
				default:
					// set date value
					that.dateValue(d);
					break;
			}
		};

		/* build year view */
		var _buildYear = function (table) {
			// build table body
			var section, row, cell;
			table.append(section = x('<TBODY/>'));
			section.append(row = x('<TR/>'));
			// add month cells
			for (var i = 0; i < 12; i++) {
				// create evenly split rows
				if (i % 3 === 0) { section.append(row = x('<TR/>')); }
				// add cell for month
				row.append(cell = x('<TD/>').attr('aria-label', _getLocale(that.lang).months[i].name).text(_getLocale(that.lang).months[i].abbr));
				cell.attr('tabindex', i === 0 ? 0 : -1);
				var d = new Date(_current.getFullYear(), i, 1);
				// add cell click event
				cell.data('date', d).on('click.slx.calendar', _cellClick).on('keyup.slx.calendar', function (event) {
					var k = event.which || event.keyCode;
					if (k === 13 || k === 32) { _cellClick.call(this); }
				});
				// set current cell
				if (i === _today.getMonth()) { cell.addClass('current'); }
				if (d.getTime() === _current.getTime()) { cell.addClass('active'); }
			}
			// update controls
			_controls.year.text(_current.getFullYear());
			_controls.previous.attr('aria-label', 'previous year');
			_controls.next.attr('aria-label', 'next year');
		};

		/* build decade view */
		var _buildDecade = function (table) {
			// build table body
			var section, row, cell;
			table.append(section = x('<TBODY/>'));
			section.append(row = x('<TR/>'));
			// add year cells
			for (var i = 0; i < 12; i++) {
				// create evenly split rows
				if (i % 3 === 0) { section.append(row = x('<TR/>')); }
				// add cell for year
				var d = new Date(_current.getFullYear() + i, _current.getMonth(), 1);
				row.append(cell = x('<TD/>').text(d.getFullYear()));
				cell.attr('tabindex', i === 0 ? 0 : -1);
				if (i === 0) {
					cell.focus();
				}
				// add cell click and enter key event
				cell.data('date', d).on('click.slx.calendar', _cellClick).on('keyup.slx.calendar', function (event) {
					var k = event.which || event.keyCode;
					if (k === 13 || k === 32) { _cellClick.call(this); }
				});
				// set current cell
				if (d.getFullYear() === _today.getFullYear()) { cell.addClass('current'); }
				if (d.getFullYear() === that.dateValue().getFullYear()) { cell.addClass('active'); }
			}
			// update controls
			_controls.year.text(_current.getFullYear() + ' - ' + (_current.getFullYear() + 11));
			_controls.previous.attr('aria-label', 'previous decade');
			_controls.next.attr('aria-label', 'next decade');
		};

		/* build month view */
		var _buildMonth = function (table, view) {
			// build table body
			var section, row, cell, i, h, d, j, n;
			table.append(section = x('<THEAD/>'));
			section.append(row = x('<TR/>'));
			// add header cells
			for (i = 0; i < 7; i++) {
				// get text values
				d = _getLocale(that.lang).days[i].abbr;
				h = _getLocale(that.lang).days[i].name;
				row.append(cell = x('<TH/>').prop({ id: that.id + '_th_' + i }).attr({ 'scope': 'col' }));
				cell.append(x('<SPAN/>').attr({ 'aria-label': h }).text(d));
				// mark business days
				cell.addClass(i === 0 || i === 6 ? 'slx-calendar-weekend' : 'slx-calendar-weekday');
			}

			// add to table
			table.append(section = x('<TBODY/>'));
			section.append(row = x('<TR/>'));

			// update controls
			var prev = _getPrevious(view), next = _getNext(view);
			if (_current.getDay() > 0) {
				var max = prev.getDaysInMonth();
				for (i = 0, j = max - _current.getDay() + 1; j <= max; j++, i++) {
					row.append(cell = x('<TD/>').text(j).addClass(i === 0 || i === 6 ? 'slx-calendar-weekend' : 'slx-calendar-weekday').addClass('muted').attr('aria-hidden', 'true'));
					d = new Date(prev.getFullYear(), prev.getMonth(), j);
					// add cell click event
					cell.data('date', d).on('click.slx.calendar', _cellClick);
				}
			}

			// add day of month cells
			for (i = 1, n = _current.getDay(), j = n; i <= _current.getDaysInMonth(); i++, n++, j++) {
				// evenly split rows
				if (j === 7) {
					j = 0;
				}
				// get current date
				d = new Date(_current.getFullYear(), _current.getMonth(), i);
				if (n > 0 && n % 7 === 0) { section.append(row = x('<TR/>')); }
				// add day cell
				row.append(cell = x('<TD/>').attr({ 'headers': that.id + '_th_' + j + ' ' + that.id + '_month ' + that.id + '_year' })
					.text(i).addClass(n % 6 === 0 || n % 7 === 0 ? 'slx-calendar-weekend' : 'slx-calendar-weekday'));
				// add click and enter key event
				cell.data('date', d).on('click.slx.calendar', _cellClick).on('keyup.slx.calendar', function (event) {
					var k = event.which || event.keyCode;
					if (k === 13 || k === 32) { _cellClick.call(this); }
				});
				// set current day cell
				cell.attr('tabindex', i === 1 ? 0 : -1);
				if (d.getTime() === _today.getTime()) { cell.addClass('current'); }
				if (d.getTime() === new Date(that.value()).getTime()) { cell.addClass('active'); }
			}

			// add remaining cells outside of current month
			var lastday = new Date(_current.getFullYear(), _current.getMonth(), _current.getDaysInMonth()).getDay();
			for (i = lastday, j = 1; i < 6; i++, j++) {
				row.append(cell = x('<TD/>').text(j).addClass(i === 0 || i === 6 ? 'slx-calendar-weekend' : 'slx-calendar-weekday').addClass('muted').attr('aria-hidden', 'true'));
				d = new Date(next.getFullYear(), next.getMonth(), j);
				// add cell click event
				cell.data('date', d).on('click.slx.calendar', _cellClick);
			}

			// update controls
			_controls.month.text(_current.getMonthName());
			_controls.year.text(_current.getFullYear());
			_controls.previous.attr('aria-label', 'previous month');
			_controls.next.attr('aria-label', 'next month');
		};

		/* build calendar views */
		var _buildCalendar = function (tableParam, view) {
			var table = tableParam;
			if (!table) { table = x('<TABLE/>'); }
			else { table.empty(); }

			// add calendar SLX classes if needed
			table.addClass('slx-calendar-calendar');
			table.addClass('slx-calendar-view-' + view);
			table.data('current', _current);

			// switch view
			switch (view) {
				case 'year':
					// switch to year view
					_buildYear(table);
					break;
				case 'decade':
					// switch to decade view
					_buildDecade(table);
					break;
				default:
					// switch to month view
					_buildMonth(table, view);
					break;
			}
			return table;
		};

		/* initialization */
		(function () {
			//_isMobile = global.innerWidth <= that.mobileMaxWidth;
			// init default required props and settings
			el.prop('id', that.id + '_container');
			el.attr({
				onchange: null,
				role: 'dialog',
				'aria-modal': 'true',
				'aria-labelledby': that.id + '_month ' + that.id + '_year',
				tabindex: 0
			});

			// add SLX classes if needed and store original value
			if (!el.hasClass('slx-calendar')) { el.addClass('slx-calendar'); }
			if (!el.data('original-val')) el.data('original-val', el.slxVal());

			// add hidden value field if needed
			if (_hidden.length === 0) {
				el.prepend(_hidden = x('<INPUT/>').attr({ id: that.id + '_value', type: 'hidden', name: that.id + '_value' }));
				if (el.data('value')) {
					_hidden.val(el.data('value'));
					var d = that.dateValue();
					_current = new Date(d.getFullYear(), d.getMonth(), 1);
				}
				_hidden.data('original-val', _hidden.slxVal());
			}

			/* add controls header */
			el.append(_controls.container = x('<DIV/>').addClass('slx-calendar-controls'));
			for (var p in _controls) {
				if (p === 'container') { continue; }
				_controls.container.append(_controls[p] = x('<A/>').attr({ tabindex: 0, href: '#', 'aria-live': 'polite' }).addClass('slx-calendar-controls-' + p));
				_controls[p].prop('id', that.id + '_' + p);
				if (['month', 'year'].includes(p)) {
					_controls[p].attr({ 'aria-controls': that.id + '_previous ' + that.id + '_next ' + that.id + '_calendar' });
				} else {
					_controls[p].attr({ 'aria-controls': that.id + '_month ' + that.id + '_year ' + that.id + '_calendar' });
				}
			}

			// build calendar
			el.append(_table = x('<TABLE/>').attr({ id: that.id + '_calendar', 'aria-live': 'polite' }));
			_buildCalendar(_table, that.view);

			// trigger render event for subscribers
			setTimeout(function () { el.trigger('render'); });
		})();

		// animating flag
		var _animating = false;

		/* events */
		(function () {
			// hidden field change event
			_hidden.off('change.slx.calendar').on('change.slx.calendar', function (event) {
				if (typeof that.onChange === 'function') {
					that.onChange.call(el[0], event);
				}
			});
			// element change event
			el.off('change.slx.calendar').on('change.slx.calendar', function () {
				var d = that.dateValue();
				// compare current w/ previous value
				if (d.getMonth() === _current.getMonth() && d.getFullYear() === _current.getFullYear()) {
					_table.find('td.active').removeClass('active');
					_table.find('td:not(.muted)').each(function (i) {
						if (x(this).data('date').getTime() === that.dateValue().getTime()) {
							x(this).addClass('active');
							return null;
						}
					});
				}
			});
			// element viewchange event
			el.off('viewchange.slx.calendar').on('viewchange.slx.calendar', function () {
				// do nothing if already animating
				if (_animating) { return; }
				_animating = true;

				// determine direction
				var t = x('<TABLE/>');
				var direction = 0;
				if (_current < _table.data('current')) { direction = -1; }
				else if (_current > _table.data('current')) { direction = 1; }
				
				var w = _table.outerWidth(true);
				// rebuild table according to direction
				switch (direction) {
					case -1:
						// build previous timeframe
						t.css({ left: (-w)+'px' });
						_table.css({ left: (-w)+'px' }).before(_buildCalendar(t, that.view));
						// animate new calendar in
						t.animate({ left: '0px' }, 300, 'ease-in-out');
						_table.animate({ left: '0px' }, 300, 'ease-in-out', function () {
							_table.empty();
							_table.append(t.children()).css('left', '0px').data('current', t.data('current'));
							t.remove();
							_animating = false;
						});
						break;
					case 1:
						// build next timeframe
						_table.after(_buildCalendar(t, that.view));
						// animate new calendar in
						_table.animate({ left: (-w)+'px' }, 300, 'ease-in-out');
						t.animate({ left: (-w)+'px' }, 300, 'ease-in-out', function () {
							_table.empty();
							_table.append(t.children()).css('left', '0px').data('current', t.data('current'));
							t.remove();
							_animating = false;
						});
						break;
					default:
						// reset calendar
						_table.empty();
						_table.append(_buildCalendar(t, that.view).children());
						_animating = false;
						break;
				}
			});

			// previous control click event
			_controls.previous.off('click.slx.calendar').on('click.slx.calendar', function (event) {
				event.preventDefault();
				_current = _getPrevious(that.view);
				// trigger viewchange event
				el.trigger('viewchange.slx.calendar');
			});
			// next control click event
			_controls.next.off('click.slx.calendar').on('click.slx.calendar', function (event) {
				event.preventDefault();
				_current = _getNext(that.view);
				// trigger viewchange event
				el.trigger('viewchange.slx.calendar');
			});
			// month control click event
			_controls.month.off('click.slx.calendar').on('click.slx.calendar', function (event) {
				event.preventDefault();
				x(this).hide();
				that.view = 'year';
				_table.removeClass('slx-calendar-view-month').addClass('slx-calendar-view-year');
				// trigger viewchange event
				el.trigger('viewchange.slx.calendar');
				_controls.year.focus();
			});
			// year control click event
			_controls.year.off('click.slx.calendar').on('click.slx.calendar', function (event) {
				event.preventDefault();
				_controls.month.hide();
				that.view = 'decade';
				_table.removeClass('slx-calendar-view-month').removeClass('slx-calendar-view-year').addClass('slx-calendar-view-decade');
				// trigger viewchange event
				el.trigger('viewchange.slx.calendar');
				_controls.year.focus();
			});
		})();

		// register control w/ event
		el[0].slxCalendar = this;
		el[0].isSlxControl = true;

		return el;
	};
	// update constructor
	x.slx.calendar.prototype = Object.create(x.slx.base.prototype);
	x.slx.calendar.prototype.constructor = x.slx.calendar;

	/* extenders */
	x.slx.extend({
		// add control init extension
		slxCalendar: function () {
			var slx = this.slxControl('slxCalendar', arguments) || new x.slx.calendar(this, arguments);
			if (arguments.length > 0) {
				var arg = arguments[0], args = Array.prototype.slice.call(arguments, 1);
				if (typeof arg === 'string' && slx.hasOwnProperty(arg)) { return typeof (slx[arg]) === 'function' ? slx[arg].apply(slx, args) : slx[arg]; }
				else if (typeof arg !== 'string') { x.extend(slx, arg); }
			}
			return this;
		}
	});
	
	// register control
	x.slx.register('slxCalendar', x.slx.slxCalendar);

	// initialize all controls by CSS class
	x(function () { x('.slx-calendar').each(function () { x(this).slxCalendar(); }); });

	/* Date polyfills */
	(function (dt) {
		var LOCALE_EN = {
			// month names and abbreviations
			months: [
				{ name: 'January', abbr: 'Jan' }, { name: 'February', abbr: 'Feb' }, { name: 'March', abbr: 'Mar' }, { name: 'April', abbr: 'Apr' }, { name: 'May', abbr: 'May' }, { name: 'June', abbr: 'June' },
				{ name: 'July', abbr: 'Jul' }, { name: 'August', abbr: 'Aug' }, { name: 'September', abbr: 'Sept' }, { name: 'October', abbr: 'Oct' }, { name: 'November', abbr: 'Nov' }, { name: 'December', abbr: 'Dec' }
			],
			// day names and abbreviations
			days: [
				{ name: 'Sunday', abbr: 'Sun' }, { name: 'Monday', abbr: 'Mon' }, { name: 'Tuesday', abbr: 'Tue' }, { name: 'Wednesday', abbr: 'Wed' }, { name: 'Thursday', abbr: 'Thu' }, { name: 'Friday', abbr: 'Fri' }, { name: 'Saturday', abbr: 'Sat' }
			],
			// date format
			format: 'MM/dd/yyyy'
		};
		// locale support
		dt.locale = {};
		// add localization to collection
		dt.addLocale = function(lang, locale) {
			// add locale collection if undefined
			if (dt.locale === void 0) {
				dt.locale = {};
			}
			// add default english localization
			if (!lang) {
				return dt.locale['en'] = LOCALE_EN;
			}
			// add other localization values
			else {
				return dt.locale[lang] = locale;
			}
		};
		// add english localization
		dt.addLocale();
		// date validator polyfill
		dt.prototype.isValid = function () {
			return Object.prototype.toString.call(this) === '[object Date]' && !isNaN(this.getTime());
		};
		// date month name polyfill
		dt.prototype.getMonthName = function (language) {
			if (!this.isValid()) { return null; }
			var lang = language && language in Date['locale'] ? language : 'en';
			return Date['locale'][lang].months[this.getMonth()].name;
		};
		// date month abbreviation polyfill
		dt.prototype.getMonthNameAbbr = function (language) {
			if (!this.isValid()) { return null; }
			var lang = language && language in Date['locale'] ? language : 'en';
			return Date['locale'][lang].months[this.getMonth()].abbr;
		};
		// date day name polyfill
		dt.prototype.getDayName = function (language) {
			if (!this.isValid()) { return null; }
			var lang = language && language in Date['locale']? language : 'en';
			return Date['locale'][lang].days[this.getDay()].name;
		};
		// date day abbreviation polyfill
		dt.prototype.getDayAbbr = function (language) {
			if (!this.isValid()) { return null; }
			var lang = language && language in Date['locale']? language : 'en';
			return Date['locale'][lang].days[this.getDay()].abbr;
		};
		// date days in month polyfill
		dt.prototype.getDaysInMonth = function () {
			if (!this.isValid()) { return null; }
			var d = new Date(this.getFullYear(), this.getMonth(), 32);
			return 32 - d.getDate();
		};
		// backup for default toString date format
		if (!dt.prototype.defaultToString) {
			dt.prototype.defaultToString = dt.prototype.toString;
			// replace date toString method polyfill
			dt.prototype.toString = function (format) {
				var f = format;
				if (f === void 0) return dt.prototype.defaultToString.call(this);
				if (f === 'd') f = 'MM/dd/yyyy';
				// pad single digit with a zero
				function pad(n) { return n < 10 ? '0' + n : n; }
				// convert military time to base 12
				function hours(n) { return n === 0 ? 12 : n > 12 ? n - 12 : n; }
				// get time meridiem
				function meridiem(n) { return n > 11 ? 'PM' : 'AM'; }
				// convert format characters to date string
				var d = f.replace('MMMM', new Intl.DateTimeFormat('en-US', { month: 'long' }).format(this));
				d = d.replace('MMM', new Intl.DateTimeFormat('en-US', { month: 'short' }).format(this));
				d = d.replace('MM', pad(this.getMonth() + 1));
				d = d.replace('M', this.getMonth() + 1);
				d = d.replace('dd', pad(this.getDate()));
				d = d.replace('d', this.getDate());
				d = d.replace('yyyy', this.getFullYear());
				d = d.replace('HH', this.getHours());
				d = d.replace('hh', pad(hours(this.getHours())));
				d = d.replace('h', hours(this.getHours()));
				d = d.replace('mm', pad(this.getMinutes()));
				d = d.replace('ss', pad(this.getSeconds()));
				d = d.replace('tt', meridiem(this.getHours()));
				d = d.replace('t', meridiem(this.getHours()).substring(0,1));
				return d;
			};
		}
	})(Date);

	return x;
})(window || this);